<template>
  <div class="docproduct">
    <Header />
    <Banner />
    <DocProductPage />
    <Footer />
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import Header from '@/components/Header.vue'
import DocProductPage from '@/components/DocProductPage.vue'

export default {
  name: 'docproduct',
  components: {
    DocProductPage,
    Header,
    Banner,
    Footer,
  }
}
</script>

<style lang="scss">

</style>